import React, { useState, useEffect } from 'react';
import './TimerView.css';
import cbseimg2 from '../../../img/sld1.jpg';
import Hero from '../../Hero';
import CBSERegistration from '../CBSERegistration';

export default function TimerView() {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      const targetDate = new Date('2026-01-25T11:00:00').getTime();
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference <= 0) {
        setIsLive(true);
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        clearInterval(timer);
      } else {
        setIsLive(false);
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setCountdown({ days, hours, minutes, seconds });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const CountdownBox = ({ value, label }) => (
    <div className="countdown-box">
      <div className="countdown-value">{String(value).padStart(2, '0')}</div>
      <div className="countdown-label">{label}</div>
    </div>
  );

  return (
    <>
    {!isLive && (<div className="timer-container">
      <div className="timer-wrapper">
        {/* Background Elements */}
        <div className="bg-decoration bg-decoration-1"></div>
        <div className="bg-decoration bg-decoration-2"></div>

        {/* Main Content */}
        <div className="timer-content">
          {/* Header Section */}
          <div className="timer-header">
            <div className="timer-badge">CBSE Job Opening</div>
            <Hero />
          </div>
          {/* Status Indicator */}
          {!isLive ? (
            <div className="status-upcoming">
              <span className="status-dot"></span>
              <span className="status-text">Accepting Applications Soon</span>
            </div>
          ) : (
            <div className="status-live">
              <span className="status-dot-live"></span>
              <span className="status-text-live">Now Accepting Applications</span>
            </div>
          )}

          {/* Countdown Timer */}
          {!isLive ? (
            <>
              <div className="countdown-wrapper">
                <CountdownBox value={countdown.days} label="Days" />
                <div className="countdown-separator">:</div>
                <CountdownBox value={countdown.hours} label="Hours" />
                <div className="countdown-separator">:</div>
                <CountdownBox value={countdown.minutes} label="Minutes" />
                <div className="countdown-separator">:</div>
                <CountdownBox value={countdown.seconds} label="Seconds" />
              </div>

              <div className="timer-info">
                <div className="info-item">
                  <i className="fas fa-calendar-alt"></i>
                  <div>
                    <p className="info-label">Opening Date</p>
                    <p className="info-value">January 25, 2026</p>
                  </div>
                </div>
                <div className="info-item">
                  <i className="fas fa-clock"></i>
                  <div>
                    <p className="info-label">Opening Time</p>
                    <p className="info-value">11:00 AM IST</p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="live-content">
              <div className="live-message">
                <h2>Applications will be soon LIVE!</h2>
                <p>Start your journey with us</p>
              </div>
            </div>
          )}

          {/* Description */}
          <div className="timer-description">
            <h3>About This Opportunity</h3>
            <p>
              We're looking for passionate educators and professionals to join our growing 
              CBSE affiliated school. Be part of a community dedicated to excellence in education 
              and student development.
            </p>
             <img src={cbseimg2} alt="CBSE" className="cbse-img" />
             
            <div className="benefits-grid">
              <div className="benefit-card">
                <i className="fas fa-graduation-cap"></i>
                <h4>Professional Growth</h4>
                <p>Continuous learning and development opportunities</p>
              </div>
              <div className="benefit-card">
                <i className="fas fa-handshake"></i>
                <h4>Supportive Culture</h4>
                <p>Collaborative and inclusive work environment</p>
              </div>
              <div className="benefit-card">
                <i className="fas fa-star"></i>
                <h4>Excellence</h4>
                <p>Commitment to academic and professional excellence</p>
              </div>
            </div>
          </div>
          

         
        </div>
      </div>
    </div>)}

     {/* Live Screen */}
          {isLive && (
            <CBSERegistration />
          )}
    </>
  );
}
